













































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import ProductViewModel from "@/chipply/view-model/ProductViewModel";
import ProductPriceDisplay from "@/components/price/ProductPriceDisplay.vue";
import IPriceDisplay from "@/chipply/interface/IPriceDisplay";

@Component({
    components: {
        ProductPriceDisplay,
    },
})
export default class BasicProductInfo extends Vue {
    @Prop({ type: Object })
    public productViewModel!: ProductViewModel;

    @Prop({ type: Boolean })
    public showMakeASelectionHeader!: boolean;

    public get priceDisplay(): IPriceDisplay {
        return {
            displayType: this.productViewModel.storePriceDisplayType,
            dollarValuePerPoint: this.productViewModel.storeDollarValuePerPoint ?? 0,
        };
    }
}
